import { render } from "./Ranking.vue?vue&type=template&id=5940a6d1&scoped=true&ts=true&lang=pug"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=5940a6d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5940a6d1"]])

export default __exports__